module.exports = __webpack_public_path__ + "static/media/CTLI_3-315w.6721af99.png";